module.exports = __webpack_public_path__ + "static/media/GBX-silver-logo.7c117c71.png";